import BaseDto from '../BaseDto';

export default class ImpotSourceDtoDto extends BaseDto {
    get schema() { // eslint-disable-line
    return Object.assign(super.schema, {
      annee: undefined,
      codeBareme: undefined,
      revenuContribuable: undefined,
      revenuConjoint: undefined,
      revenuGlobal: undefined,
      revenuPourTaux: undefined,
      tauxContribuable: undefined,
      tauxConjoint: undefined,
      tauxGlobal: undefined,
      impotDuContribuable: undefined,
      impotDuConjoint: undefined,
      impotDuGlobal: undefined,
      impotRemboursement: undefined,
      isPourLeTaux: undefined,
    });
  }

  buildCustom() {
    super.buildCustom();
    return this;
  }

  static getFactory(jsonData = {}) {
    return new ImpotSourceDtoDto(jsonData);
  }
}
